<template>
	<span>
		<div  v-if="iamin=='myshop'" class="socialIcondiv">
		<span class="shrNowText"><small>Share Now </small></span>
		
		<b-link @click="$root.updateShare(productData),$root.shareProduct(),setiamiconfor('sms')"><b-img  src="@/assets/sms.svg" class="socialIcondiv--icon"></b-img></b-link>
		<b-link @click="$root.updateShare(productData),$root.shareProduct(),setiamiconfor('facebook')"><b-img  src="@/assets/facebook.svg" class="socialIcondiv--icon"></b-img></b-link>
		<b-link @click="$root.updateShare(productData),$root.shareProduct(),setiamiconfor('whatsapp')"><b-img  src="@/assets/whatsapp.svg" class="socialIcondiv--icon"></b-img></b-link>
		<b-link @click="$root.updateShare(productData),$root.shareProduct(),setiamiconfor('twitter')"><b-img  src="@/assets/twitter.svg" class="socialIcondiv--icon"></b-img></b-link>
		<b-link @click="$root.updateShare(productData),$root.shareProduct(),setiamiconfor('telegram')"><b-img  src="@/assets/telegram.svg" class="socialIcondiv--icon"></b-img></b-link>
		</div>
		
		<div  v-if="iamin=='product'" class="socialIcondivproduct">
		Share Now
		<b-link @click="$root.updateShare(productData),$root.shareProduct(),setiamiconfor('sms')"><b-img  src="@/assets/sms.svg" class="socialIcondivproduct--icon"></b-img></b-link>
		<b-link @click="$root.updateShare(productData),$root.shareProduct(),setiamiconfor('facebook')"><b-img  src="@/assets/facebook.svg" class="socialIcondivproduct--icon"></b-img></b-link>
		<b-link @click="$root.updateShare(productData),$root.shareProduct(),setiamiconfor('whatsapp')"><b-img  src="@/assets/whatsapp.svg" class="socialIcondivproduct--icon"></b-img></b-link>
		<b-link @click="$root.updateShare(productData),$root.shareProduct(),setiamiconfor('twitter')"><b-img  src="@/assets/twitter.svg" class="socialIcondivproduct--icon"></b-img></b-link>
		<b-link @click="$root.updateShare(productData),$root.shareProduct(),setiamiconfor('telegram')"><b-img  src="@/assets/telegram.svg" class="socialIcondivproduct--icon"></b-img></b-link>
		</div>
	</span>
</template>
<script>
export default {
  name: 'ShareiconButton',
  props: {
    productData: { type: Object },	
    iamin: String,	
  },
  mounted(){
  //this.inLodcard;
  },
  computed: {
    //
  },
  data() {
    return{
      //modaldata_qty: 1,
	  //variant:'dark',
	  //cartHeader:'',
        //{{$root.cart.quantity}}
    }
  },
  methods:{
		addtofavouriteNotlogin(){
			if(this.$root.customer_info.access_key == ''){
				this.$router.push({
					name: 'Login',
					params: {
						redirect: '/category/'+this.$route.params.category
					}
				});
			}
		},
		setiamiconfor(socialame){
		this.$root.share.iamiconfor=socialame;
		}
		
	/* inLodcard(){
	this.cartHeader ='
	} */
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style   scoped lang="scss">
.addtoshopNow{
	color: rgb(254 100 111);
    font-size: 30px;
}

.socialIcondivproduct{
			
			width:100%;
			position: absolute;
			margin-top: 3%;
			text-align: left;
			&--icon{
				width:30px;
				margin:3%;
			}
			
		}
</style>
